/* QC HOMEPAGE V2 (qc-hp-* sections) - behaviour ported from the designer's index.html.
   Loaded with defer by each qc-hp section; safe to load more than once. */
(function () {
  if (window.__qcHp) return;
  window.__qcHp = true;

  var doc = document.documentElement;
  var MOBILE = '(max-width: 819px)';

  /* Horizon (base.css, 990px and up) locks html/body and scrolls .page-wrapper instead of the window,
     so read the scroll position and the usable width from whichever one is actually scrolling. */
  function pageWrap() { return document.querySelector('.page-wrapper'); }
  function scrollPos() { var pw = pageWrap(); return Math.max(window.scrollY || 0, pw ? pw.scrollTop : 0); }

  /* Viewport width without the scrollbar, used by qc-hp.css for scaling. */
  function setVw() {
    var w = doc.clientWidth, pw = pageWrap();
    if (pw && pw.clientWidth && pw.clientWidth < w) w = pw.clientWidth;
    doc.style.setProperty('--qc-vw', w + 'px');
  }

  /* Only the visible layout (desktop or mobile) loads and plays its autoplay videos. */
  function syncVideos() {
    document.querySelectorAll('.qc-hp-auto video').forEach(function (v) {
      v.muted = true;
      var shown = v.offsetParent !== null;
      if (shown) {
        if (v.preload !== 'auto') { v.preload = 'auto'; v.load(); }
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      } else if (!v.paused) { v.pause(); }
    });
  }

  /* ---------- Floating header ----------
     Homepage (QC hero): fades in once the visitor scrolls; on desktop the hero wordmark flies into it
     and flies back when they return to the top. Other pages: always shown, pinned below the banner
     pill until the pill scrolls away, then pinned to the top. */
  var stOn = null, flyTimer = null;
  function shown(sel) {
    var a = document.querySelectorAll(sel);
    for (var i = 0; i < a.length; i++) if (a[i].offsetParent !== null) return a[i];
    return null;
  }
  function fly(fromEl, toEl, toWhite, done) {
    var f = fromEl.getBoundingClientRect(), t = toEl.getBoundingClientRect();
    if (!f.width || !t.width) { done && done(); return; }
    var c = fromEl.cloneNode(false);
    c.removeAttribute('style'); c.removeAttribute('class'); c.className = 'qc-hp-fly'; c.alt = '';
    c.style.left = f.left + 'px'; c.style.top = f.top + 'px'; c.style.width = f.width + 'px'; c.style.height = f.height + 'px';
    c.style.filter = toWhite ? 'none' : 'brightness(0) invert(1)';
    document.body.appendChild(c);
    c.getBoundingClientRect();
    c.style.transform = 'translate(' + (t.left - f.left) + 'px,' + (t.top - f.top) + 'px) scale(' + (t.width / f.width) + ')';
    c.style.filter = toWhite ? 'brightness(0) invert(1)' : 'none';
    clearTimeout(flyTimer);
    document.querySelectorAll('.qc-hp-fly').forEach(function (o) { if (o !== c) o.remove(); });
    flyTimer = setTimeout(function () { c.remove(); done && done(); }, 720);
  }
  function setStick(st, on) {
    if (on === stOn) return;
    var first = stOn === null; stOn = on;
    var heroLogo = shown('.qc-hdr__d .qc-hdr__wm');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (on) {
      st.classList.add('on');
      var bar = shown('.qc-st .qc-st__logo');
      if (heroLogo && bar && !first && !reduce) {
        heroLogo.style.visibility = 'hidden';
        fly(heroLogo, bar, false, function () { if (stOn) st.classList.add('landed'); });
      } else {
        if (heroLogo) heroLogo.style.visibility = 'hidden';
        st.classList.add('landed');
      }
    } else {
      closeAllShops();
      var bar2 = shown('.qc-st .qc-st__logo');
      st.classList.remove('landed');
      if (heroLogo && bar2 && !first && !reduce) {
        fly(bar2, heroLogo, true, function () { if (!stOn) heroLogo.style.visibility = ''; });
      } else if (heroLogo) heroLogo.style.visibility = '';
      st.classList.remove('on');
    }
  }
  function syncHeader() {
    var st = document.querySelector('.qc-st');
    if (!st) return;
    var hero = document.querySelector('.qc-hp-hero, .qc-pg-ph');
    if (hero) {
      st.style.top = '0px';
      setStick(st, scrollPos() > 24);
    } else {
      var ann = document.querySelector('.qc-hdr .qc-hp-ann');
      st.style.top = (ann ? Math.max(0, ann.getBoundingClientRect().bottom) : 0) + 'px';
      st.classList.add('on', 'landed');
    }
  }

  /* ---------- Cart: open Horizon's cart drawer when the theme uses one, keep the count fresh ---------- */
  function openCartDrawer() {
    var d = document.getElementById('cart-drawer');
    if (d && typeof d.open === 'function') { d.open(); return true; }
    return false;
  }
  function refreshCartCount() {
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { document.querySelectorAll('.qc-hp-cart-count').forEach(function (el) { el.textContent = c.item_count; }); })
      .catch(function () {});
  }
  function setCartCount(n) { document.querySelectorAll('.qc-hp-cart-count').forEach(function (el) { el.textContent = n; }); }
  /* Horizon's cart events (theme buy buttons, cart drawer, and the QC buy boxes, which add through their own
     fetch so the wrapper below never sees them): take the new count from the event, or re-read /cart.js. */
  (async function () {
    try {
      var ev = await import('@shopify/events');
      document.addEventListener(ev.StandardEvents.cartLinesUpdate, function (e) {
        var p = e && e.promise;
        if (p && p.then) {
          p.then(function (r) {
            var n = r && r.cart && r.cart.totalQuantity;
            if (typeof n === 'number') setCartCount(n); else refreshCartCount();
          }, function () {});
        } else { setTimeout(refreshCartCount, 300); }
      });
    } catch (err) {}
  })();
  /* Safety net for the QC buy boxes: re-read the cart shortly after their add-to-cart event */
  document.addEventListener('qc:add-to-cart', function () { setTimeout(refreshCartCount, 1500); });
  if (window.fetch && !window.__qcHpFetch) {
    window.__qcHpFetch = true;
    var _fetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = _fetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(url)) { p.then(function () { setTimeout(refreshCartCount, 50); }).catch(function () {}); }
      return p;
    };
  }

  /* ---------- SHOP dropdown ---------- */
  function setShop(btn, open) {
    var dd = document.getElementById(btn.getAttribute('aria-controls'));
    if (!dd) return;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    dd.classList.toggle('open', open);
  }
  function closeAllShops() {
    document.querySelectorAll('.qc-hp-shop[aria-expanded="true"]').forEach(function (b) { setShop(b, false); });
  }

  /* ---------- Mobile menu drawer ---------- */
  function setDrawer(drawer, open) {
    if (!drawer) return;
    drawer.classList.toggle('open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    doc.classList.toggle('qc-hp-lock', open);
    if (open) { var f = drawer.querySelector('.qc-hp-drawer__nav a'); if (f) f.focus({ preventScroll: true }); }
  }

  /* Buttons with data-qc-open-shop (QC HP: Creatine offer, "Button action" setting): scroll to the top, then
     open the header's Shop dropdown. On mobile there is no Shop dropdown, so the menu drawer opens instead. */
  var shopJump = 0;
  /* ---- Old Shop All page: /collections/all is retired; links to it go to the homepage Shop dropdown (2026-10-31) ---- */
  function rootUrl() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function shopHomeUrl() { return rootUrl() + '?qc_shop=1'; }
  function isHome() { var r = rootUrl(), p = window.location.pathname; return p === r || p + '/' === r; }
  function isOldShopAll(a) {
    if (a.hasAttribute('data-qc-allow-shop-all')) return false;
    try { var u = new URL(a.href, window.location.href); return u.origin === window.location.origin && /\/collections\/all\/?$/.test(u.pathname); } catch (err) { return false; }
  }
  function rewriteOldShopLinks() {
    document.querySelectorAll('a[href*="/collections/all"]').forEach(function (a) { if (isOldShopAll(a)) a.setAttribute('href', shopHomeUrl()); });
  }
  /* Arrived from one of those links (/?qc_shop=1): drop the flag from the address bar and open the dropdown */
  function openShopFromUrl() {
    if (!/[?&]qc_shop=1/.test(window.location.search)) return;
    try { var u = new URL(window.location.href); u.searchParams.delete('qc_shop'); history.replaceState(history.state, '', u.pathname + u.search + u.hash); } catch (err) {}
    var tries = 0;
    (function go() {
      if (openShopMenu({ href: rootUrl() })) return;
      if (++tries < 20) setTimeout(go, 150);
    })();
  }
  function scrollTopNow(smooth) {
    var pw = pageWrap(), opt = { top: 0, behavior: smooth ? 'smooth' : 'auto' };
    window.scrollTo(opt);
    if (pw && pw.scrollTop > 0) pw.scrollTo(opt);
  }
  function openShopMenu(link) {
    if (window.matchMedia(MOBILE).matches) {
      var burger = shown('[data-qc-hp-menu]');
      if (burger) { setDrawer(document.getElementById(burger.getAttribute('aria-controls')), true); return true; }
      return false;
    }
    if (!shown('.qc-hp-shop')) return false;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var id = ++shopJump, t0 = Date.now();
    scrollTopNow(!reduce);
    (function wait() {
      if (id !== shopJump) return;
      /* wait until the page is back at the top (the floating header closes the dropdown while it hides) */
      if (scrollPos() > 2 && Date.now() - t0 < 1500) { requestAnimationFrame(wait); return; }
      if (scrollPos() > 2) scrollTopNow(false);
      setTimeout(function () {
        if (id !== shopJump) return;
        var btn = shown('.qc-hp-shop');
        if (!btn) { window.location.href = link.href; return; }
        closeAllShops();
        setShop(btn, true);
        btn.focus({ preventScroll: true });
      }, 120);
    })();
    return true;
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var jump = t.closest('[data-qc-open-shop]');
    if (jump) { if (openShopMenu(jump)) e.preventDefault(); return; }
    /* Old Shop All page (/collections/all): every link to it opens the homepage Shop dropdown instead */
    var oldShop = t.closest('a[href]');
    if (oldShop && isOldShopAll(oldShop)) {
      e.preventDefault();
      if (isHome() && !oldShop.closest('dialog, cart-drawer-component, .cart-drawer') && openShopMenu({ href: shopHomeUrl() })) return;
      window.location.href = shopHomeUrl();
      return;
    }
    var shop = t.closest('.qc-hp-shop');
    if (shop) { e.preventDefault(); setShop(shop, shop.getAttribute('aria-expanded') !== 'true'); return; }
    if (!t.closest('.qc-hp-dd')) closeAllShops();

    var cartLink = t.closest('[data-qc-cart]');
    if (cartLink) {
      var dr = cartLink.closest('.qc-hp-drawer');
      if (openCartDrawer()) { e.preventDefault(); if (dr) setDrawer(dr, false); return; }
    }

    var burger = t.closest('[data-qc-hp-menu]');
    if (burger) { e.preventDefault(); setDrawer(document.getElementById(burger.getAttribute('aria-controls')), true); return; }
    var close = t.closest('[data-qc-hp-close]');
    if (close) { setDrawer(close.closest('.qc-hp-drawer'), false); return; }

    var tab = t.closest('.qc-hp-invest__tab');
    if (tab) { pickSlide(tab); return; }

    var play = t.closest('.qc-hp-vid__play');
    if (play) { toggleVid(play.closest('.qc-hp-vid')); return; }
  });
  document.addEventListener('mouseover', function (e) {
    var tab = e.target.closest && e.target.closest('.qc-hp-invest__tab');
    if (tab) pickSlide(tab);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeAllShops();
    document.querySelectorAll('.qc-hp-drawer.open').forEach(function (d) { setDrawer(d, false); });
  });

  /* ---------- This is QUiET COYOTE: hover or tap 01 to 05 ---------- */
  function pickSlide(tab) {
    var root = tab.closest('.qc-hp-invest');
    var i = +tab.getAttribute('data-i');
    root.querySelectorAll('.qc-hp-invest__tab').forEach(function (b, k) { b.classList.toggle('on', k === i); b.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
    root.querySelectorAll('.qc-hp-invest__media img').forEach(function (m, k) { m.classList.toggle('on', k === i); });
    root.querySelectorAll('.qc-hp-invest__slide').forEach(function (s, k) {
      s.classList.toggle('on', k === i); s.classList.toggle('before', k < i);
      s.setAttribute('aria-hidden', k === i ? 'false' : 'true');
    });
  }

  /* ---------- Customer videos ---------- */
  function toggleVid(card) {
    var v = card && card.querySelector('video');
    if (!v) return;
    if (v.paused) {
      document.querySelectorAll('.qc-hp-vid.is-playing video').forEach(function (o) { if (o !== v) o.pause(); });
      v.muted = false; v.controls = true; var p = v.play(); if (p && p.catch) p.catch(function () {});
    } else { v.pause(); }
  }
  document.addEventListener('play', function (e) { var c = e.target.closest && e.target.closest('.qc-hp-vid'); if (c) c.classList.add('is-playing'); }, true);
  document.addEventListener('pause', function (e) { var c = e.target.closest && e.target.closest('.qc-hp-vid'); if (c) c.classList.remove('is-playing'); }, true);

  function initCarousel(root) {
    if (root.__qcInit) return; root.__qcInit = true;
    var row = root.querySelector('.qc-hp-videos__row');
    var prev = root.querySelector('[data-dir="-1"]'), next = root.querySelector('[data-dir="1"]');
    var thumb = root.querySelector('.qc-hp-videos__thumb');
    if (!row) return;
    function step() {
      var c = row.firstElementChild; if (!c) return 0;
      return c.getBoundingClientRect().width + parseFloat(getComputedStyle(row).columnGap || 0);
    }
    if (prev) prev.addEventListener('click', function () { row.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { row.scrollBy({ left: step(), behavior: 'smooth' }); });
    function upd() {
      var max = row.scrollWidth - row.clientWidth, frac = row.clientWidth / Math.max(row.scrollWidth, 1);
      var w = Math.max(frac * 100, 12), pos = max > 0 ? row.scrollLeft / max : 0;
      if (thumb) { thumb.style.width = w + '%'; thumb.style.left = (pos * (100 - w)) + '%'; }
      if (prev) prev.style.opacity = row.scrollLeft < 4 ? .35 : 1;
      if (next) next.style.opacity = row.scrollLeft > max - 4 ? .35 : 1;
    }
    row.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  }

  function initAll() {
    setVw();
    document.querySelectorAll('.qc-hp-videos').forEach(initCarousel);
    syncVideos();
    syncHeader();
  }

  window.addEventListener('resize', function () { setVw(); syncVideos(); syncHeader(); });
  /* capture: also hears .page-wrapper scrolling (scroll events on elements do not bubble) */
  document.addEventListener('scroll', syncHeader, { passive: true, capture: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  function initShopAll() { rewriteOldShopLinks(); openShopFromUrl(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initShopAll); else initShopAll();

  /* ---------- Scroll zoom on images (rhodeskin.com style, 2026-11-02) ----------
     Every photo/video in a qc-hp section (not the hero) starts at 120% as it comes up from the bottom of
     the screen and settles to 100% by the time it leaves the top. Its frame clips the edges. Uses the CSS
     "scale" property, so it stacks with any transform a section already sets (hover zooms, mobile crops).
     Opt a section or image out with data-qc-no-zoom. Off for visitors who ask for reduced motion.
     Product pages (2026-11-03): qc-lp/qc-cr/qc-ct/qc-nb sections opt IN with data-qc-zoom (their "Image zoom on scroll" setting). */
  var ZOOM_FROM = 1.2, zoomItems = [], zoomRaf = 0;
  function clips(el) { var c = getComputedStyle(el); return /(hidden|clip)/.test(c.overflow + ' ' + c.overflowX + ' ' + c.overflowY); }
  function zoomInit() {
    zoomItems.forEach(function (it) { it.el.style.scale = ''; });
    zoomItems = [];
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('.qc-hp-section img, .qc-hp-section video, [data-qc-zoom] img, [data-qc-zoom] video').forEach(function (el) {
      if (el.closest('.qc-hp-hero, .qc-hdr, [data-qc-no-zoom]')) return;
      var box = el.parentElement;
      /* only images whose frame clips them, so the zoom never spills over the layout */
      if (!box || !(clips(box) || (box.parentElement && clips(box.parentElement)))) return;
      zoomItems.push({ el: el, cur: null });
    });
    zoomTick();
  }
  function ease(p) { return (p + (1 - Math.cos(Math.PI * p)) / 2) / 2; } /* between linear and sine in-out, measured off rhode */
  function zoomTick() {
    zoomRaf = 0;
    var vh = window.innerHeight, moving = false;
    zoomItems.forEach(function (it) {
      var r = it.el.getBoundingClientRect();
      if (!r.height || r.bottom < -vh * 0.25 || r.top > vh * 1.25) { it.cur = null; return; }
      var p = Math.min(1, Math.max(0, (vh - r.top) / (vh + r.height)));
      var target = ZOOM_FROM - (ZOOM_FROM - 1) * ease(p);
      it.cur = it.cur == null ? target : it.cur + (target - it.cur) * 0.14; /* smoothing, like the original */
      if (Math.abs(target - it.cur) > 0.0005) moving = true; else it.cur = target;
      it.el.style.scale = it.cur.toFixed(4);
    });
    if (moving) zoomRaf = requestAnimationFrame(zoomTick);
  }
  function zoomKick() { if (!zoomRaf && zoomItems.length) zoomRaf = requestAnimationFrame(zoomTick); }
  /* capture: also hears .page-wrapper scrolling (Horizon scrolls that instead of the window on desktop) */
  document.addEventListener('scroll', zoomKick, { capture: true, passive: true });
  window.addEventListener('resize', zoomKick, { passive: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', zoomInit); else zoomInit();
  window.addEventListener('load', zoomKick);
  document.addEventListener('shopify:section:load', zoomInit);

  /* Theme editor: re-init a section after it is edited or re-rendered */
  document.addEventListener('shopify:section:load', function () { stOn = null; initAll(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCartCount(); });
})();
